import { setUser } from '@sentry/react';
import { useOidcUserProfile } from '@vs/oidc-client';
import { useEffect } from 'react';

export default function useSetUserProfile() {
  const userProfile = useOidcUserProfile();

  useEffect(() => {
    setUser(
      userProfile
        ? {
            sub: userProfile.sub,
            email: userProfile.email,
            account: userProfile.account,
          }
        : null
    );
  }, [userProfile]);
}
